import format from "date-fns/format";
import { enUS, es } from "date-fns/locale";
import { Component, Vue } from "vue-property-decorator";
import { i18n } from "./i18n";
import { IPais, IUsuario } from "@/entities";
import { Getter } from "vuex-class";

declare module "vue/types/vue" {
  interface Vue {
    filterDate(dateStr: string): string;
    filterLocalDate(dateStr: string): string;
    filterTime(dateStr: string): string;
    filterLocalTime(dateStr: string): string;
    filterDateTime(dateStr: string): string;
    filterLocalDateTime(dateStr: string): string;
    filterNumber(amount: number, decimals?: number): string;
  }
}

@Component({
  name: "vue-filters",
})
export default class VueFilters extends Vue {
  @Getter("getLoggedUser") getLoggedUser!: IUsuario;
  public filterDate(dateStr: string): string {
    let locale = enUS;

    if (i18n.locale === "es") {
      locale = es;
    }
    const dateformat = this.getDateFormat(this.getLoggedUser.pais, false);

    const date = new Date(dateStr);

    if (
      !date.getUTCHours() &&
      !date.getUTCMinutes() &&
      !date.getUTCSeconds() &&
      !date.getUTCMilliseconds()
    ) {
      //Ajustamos para que en todos los paises salga la fecha correcta sin la hora
      date.setTime(date.valueOf() + date.getTimezoneOffset() * 60 * 1000);
    }

    return dateStr ? format(date, dateformat, { locale }) : "";
  }

  public filterLocalDate(dateStr: string): string {
    let locale = enUS;

    if (i18n.locale === "es") {
      locale = es;
    }
    const dateformat = this.getDateFormat(this.getLoggedUser.pais, false);
    const date = new Date(dateStr);
    date.setTime(date.valueOf() + date.getTimezoneOffset() * 60 * 1000);

    return dateStr ? format(date, dateformat, { locale }) : "";
  }

  private getDateFormat(pais: IPais | undefined, enableHour: boolean): string {
    const dateByDefault = "dd/MM/yyyy";
    if (!pais) {
      return dateByDefault;
    }
    if (!pais.dateFormat) {
      return dateByDefault;
    }
    return !enableHour ? pais.dateFormat : pais.dateFormat.concat(" ").concat("HH:mm");
  }

  public filterTime(dateStr: string): string {
    let locale = enUS;

    if (i18n.locale === "es") {
      locale = es;
    }

    return dateStr ? format(new Date(dateStr), "HH:mm", { locale }) : "";
  }

  public filterLocalTime(dateStr: string): string {
    let locale = enUS;

    if (i18n.locale === "es") {
      locale = es;
    }

    const dateformat = "HH:mm";
    const date = new Date(dateStr);
    date.setTime(date.valueOf() + date.getTimezoneOffset() * 60 * 1000);

    return dateStr ? format(date, dateformat, { locale }) : "";
  }

  public filterDateTime(dateStr: string): string {
    let locale = enUS;

    if (i18n.locale === "es") {
      locale = es;
    }
    const dateformat = this.getDateFormat(this.getLoggedUser.pais, true);

    return dateStr ? format(new Date(dateStr), dateformat, { locale }) : "";
  }

  public filterLocalDateTime(dateStr: string): string {
    let locale = enUS;

    if (i18n.locale === "es") {
      locale = es;
    }
    const dateformat = this.getDateFormat(this.getLoggedUser.pais, true);
    const date = new Date(dateStr);
    date.setTime(date.valueOf() + date.getTimezoneOffset() * 60 * 1000);

    return dateStr ? format(date, dateformat, { locale }) : "";
  }

  public filterNumber(amount = 0, decimals = 2): string {
    const lang = this.getLoggedUser.pais?.idioma?.toLowerCase();
    const country = this.getLoggedUser.pais?.codPaisCorto?.toUpperCase();
    const locale = `${lang}-${country}`;

    try {
      return Number(amount || 0).toLocaleString(locale, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      });
    } catch (e) {
      // Si hay un error con el locale, usamos un fallback ('es-ES')
      console.warn(`Locale no válido: ${locale}, usando fallback 'es-ES'`);
      return Number(amount || 0).toLocaleString("es-ES", {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      });
    }
  }
}
